class s extends HTMLElement {
  constructor() {
    super(), this.element = this.querySelector(".mosaic-container"), this.handleScroll = this.handleScroll.bind(this), this.init(), this.handleScroll();
  }
  handleScroll() {
    if (!this.element) return;
    const e = this.element.getBoundingClientRect(), t = 100 - e.bottom / (e.height + window.innerHeight) * 100, n = Math.max(Math.min(100, t), 0);
    this.element.style.setProperty("--percentage", n.toString()), this.element.style.setProperty("--opacity", "1");
  }
  init() {
    if (!this.element) return;
    new IntersectionObserver((t) => {
      t.forEach((n) => {
        n.isIntersecting ? document.addEventListener("scroll", this.handleScroll) : document.removeEventListener("scroll", this.handleScroll);
      });
    }).observe(this.element);
  }
}
window.customElements.get("scroll-progress") || window.customElements.define("scroll-progress", s);
